module.exports = __webpack_public_path__ + "static/assets/00a42ec539deb373d4d933a249b1dae7.png";